import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-right":"10px"} }


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetSearchBtn',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit;

function toggle() {
  emit("update:modelValue", !props.modelValue);
}


return (_ctx: any,_cache: any) => {
  const _component_sc_btn = _resolveComponent("sc-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_sc_btn, {
      handler: toggle,
      icon: "DownOutlined"
    }, null, 512), [
      [_vShow, _ctx.modelValue]
    ]),
    _withDirectives(_createVNode(_component_sc_btn, {
      type: "primary",
      handler: toggle,
      icon: "SearchOutlined"
    }, null, 512), [
      [_vShow, !_ctx.modelValue]
    ])
  ]))
}
}

})